import { render } from "./ManualUpdater.vue?vue&type=template&id=37fb7173"
import script from "./ManualUpdater.vue?vue&type=script&lang=js"
export * from "./ManualUpdater.vue?vue&type=script&lang=js"

import "./ManualUpdater.vue?vue&type=style&index=0&id=37fb7173&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__